<template>
  <div class="suspen_box" :class="fadeInRight ? 'ke_animation_fadeInRight' : ''">
    <i class="el-icon-caret-left suspen_corner" @click="fadeInRight = true"></i>
    <div class="icon_box">
      <!-- <div class="icon_item tel_item">
        <img src="../assets/images/suspen1.png" alt="" />
        <div class="tel_box">400 0691 000<span></span></div>
      </div> -->
      <div class="icon_item webchat_item media_small_hide">
        <img src="../assets/images/suspen2.png" alt="" />
        <div class="wx_box">
          <img src="../assets/images/wx-code.png" alt="" /><span></span>
        </div>
      </div>
      <!-- <div class="icon_item webchat_item media_small_hide">
        <img src="../assets/images/suspen5.png" alt="" />
        <div class="wx_box">
          <img src="../assets/images/download-app.png" alt="" /><span></span>
        </div>
      </div> -->
      <!-- <a target="_blank" class="icon_item" href="https://cschat-ccs.aliyun.com/index.htm?tntInstId=_2JIZ9km&scene=SCE00009964"><img src="../assets/images/suspen3.png" alt=""></a> -->
      <div class="icon_item" @click="chatOpen">
        <img src="../assets/images/suspen3.png" alt="" />
      </div>
      <div class="icon_item" id="backtop" @click="getScrollTop()">
        <img src="../assets/images/suspen4.png" alt="" />
      </div>
    </div>
    <div class="chat_box" v-if="chatShow">
      <!-- <div class="char-content" :style="'width:' + charWidth + 'px'">
        <img
          class="char-close"
          src="@/assets/images/charClose.png"
          @click="chatHide"
          alt=""
        />
        <iframe
          src="https://customer.kaiergeye.com/webchatMain.action?targetId=uckf.200000210013&hide_close=1&callerInfo="
          frameborder="0"
          style="width: 100%; height: 100%"
          id="iframeBox"
        ></iframe>
      </div> -->
      <div class="chat_header">
        <div class="server">
          <div class="server_avatar"><img src="../assets/images/logo.png" alt=""></div>
          开尔客服
        </div>
        <div class="el-icon-close close_btn" @click="chatShow=false"></div>
      </div>
      <div class="chat_main" id="chatBox">
        <div class="item_box" :class="{'left':item.type=='a'||item.type=='r','right':item.type=='q'}" v-for="(item,index) in chatList" :key="index">
          <div class="chat_item">{{item.text}}</div>
          <div class="recommend_list" v-if="item.type=='r'">
            <div class="recommend_item" v-for="(ele,i) in item.recommendList" :key="i" @click="chooseQuestion(ele.Title)">{{ele.Title}}</div>
          </div>
        </div>
      </div>
      <div class="input_box">
        <el-input placeholder="请输入" v-model="chatInputValue" @keyup.enter.native="sendChat()"></el-input>
        <div class="send_btn" @click="sendChat">发送</div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript" src="https://customer.kaiergeye.com/webchat.action?targetId=200000210013&callerInfo="></script>
<script>
import common from "../api/common";
export default {
  data() {
    return {
      fadeInRight: false,
      charWidth: "850",
      interval: null,
      answer: "不好意思，我不是很理解您的问题，请用一句话准确描述",
      chatShow: false,
      chatList: [],
      chatInputValue: "",
      timer1: "",
      timer2: "",
      chatData: {
        message: "",
        sessionId: "",
        senderNick: "",
      },
    };
  },
  watch: {
    chatList() {
      this.$nextTick(() => {
        let element = document.getElementById("chatBox");
        element.scrollTop = element.scrollHeight;
      });
    },
  },
  methods: {
    getScrollTop() {
      // window.scrollTo(0,0)
      var backTop = document.getElementById("backtop"),
        topH, //滚动条距离顶部高度
        backTopSpeed, //滚动速度
        backTopTimer; //定时器
      backtop.addEventListener("click", function () {
        var backTopTimer = setInterval(function () {
          topH = document.documentElement.scrollTop || document.body.scrollTop;
          backTopSpeed = Math.floor(-topH / 40); //取整
          if (topH > 0) {
            document.documentElement.scrollTop = document.body.scrollTop =
              topH + backTopSpeed;
          } else {
            clearInterval(backTopTimer);
          }
        }, 15);
      });
    },
    getChat(){
      common.getChat(this.chatData).then(res=>{
        if(res){
          console.log(res);
          this.chatData.sessionId = res.data.SessionId;
          if(res.data.Messages){
            res.data.Messages.forEach(item=>{
              let msg = {}
              if(item.Type=='Text'){
                if(item.Text.AnswerSource=='NO_ANSWER'){
                  msg.text = '亲，您的问题小蜜还不会哦～ 换一种问法试试吧';
                  msg.type = 'a';
                }else{
                  msg.text = item.Text.Content;
                  msg.type = 'a';
                }
              }else if(item.Type=='Knowledge'){
                msg.text = item.Knowledge.Content;
                msg.type = 'a';
              }else if(item.Type=='Recommend'){
                msg.text = '您是不是想问：';
                msg.type = 'r';   //有推荐问题
                msg.recommendList = item.Recommends;
              }
              this.chatList.push(msg);
            })
          }
          console.log(this.chatList);
        }
      })
    },
    sendChat(){
      if(this.chatInputValue){
        let obj = {
          text:this.chatInputValue,
          type:'q'
        }
        this.chatList.push(obj);    //把问题push进聊天框
        this.timer1 = setTimeout(()=>{
          this.chatInputValue = "";
        },20)
      }else{
        return
      }
      this.chatData.message = this.chatInputValue;
      this.getChat();
      // return

      // let chatInputValue = this.chatInputValue;
      // this.timer1 = setTimeout(()=>{
      //   this.chatInputValue = "";
      // },20)
      // if(chatInputValue){
      //   let obj = {
      //     text:chatInputValue,
      //     type:'q'
      //   }
      //   this.chatList.push(obj);
      //   let answer={};
      //   if(chatInputValue=="几号开始收鸽？"){
      //     answer={
      //       text:'请问您说的是哪个棚？',
      //       type:'a'
      //     }
      //   }else if(chatInputValue=="你们的公棚"){
      //     answer={
      //       text:'现在就开始收鸽了，您可以在官网或下载邢小信app登录后预约预订收鸽。',
      //       type:'a'
      //     }
      //   }else{
      //     answer={
      //       text:'不好意思，我不是很理解您的问题，请用一句话准确描述',
      //       type:'a'
      //     }
      //   }
      //   this.timer2 = setTimeout(()=>{
      //     this.chatList.push(answer);
      //   },1000)
      // }
    },
    chatOpen() {
      // window.location.href='https://kaier.s2.udesk.cn/im_client/?web_plugin_id=68646'
      window.open('https://kaier.s2.udesk.cn/im_client/?web_plugin_id=68646','_blank')
      // this.chatShow = true;
      // let answer={
      //   text:'请问有什么可以帮您？',
      //   type:'a'
      // }
      // this.chatList.push(answer);
    },
    chatHide() {
      console.log(1111);
      this.chatShow = false;
    },
    chooseQuestion(title){
      let obj = {
        text:title,
        type:'q'
      }
      this.chatList.push(obj);    //把问题push进聊天框
      this.chatData.message = title;
      this.getChat();
    }
  },
  created() {
    this.screenWidth = document.body.clientWidth;
    if (this.screenWidth < 850) {
      this.charWidth = this.screenWidth;
    } else {
      this.charWidth = "850";
    }
  },
  watch: {
    screenWidth(val) {
      this.screenWidth = val;
      if (this.screenWidth < 850) {
        this.charWidth = this.screenWidth;
      } else {
        this.charWidth = "850";
      }
    },
    chatShow: function (newVal) {
      if (newVal) {
        document.querySelector("body").style.overflow = "hidden";
      }
      if (!newVal) {
        document.querySelector("body").style.overflow = "visible";
      }
    },
  },
  mounted() {},
  beforeDestroy() {
    clearInterval(this.timer1);
    clearInterval(this.timer2);
  },
};
</script>


// WEBPACK FOOTER //
// src/components/suspen.vue